module.exports = __webpack_public_path__ + "media/images/lb/609-88af7f00f4da17287ffa67ea4cd3b775.svg";